var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"appLoginPage"},[_vm._v(" 您无需填报消防工作相关人员名单! ")])])
}]

export { render, staticRenderFns }